// extracted by mini-css-extract-plugin
module.exports = {"main":"📦Sample__main--3blZ_","scanner":"📦Sample__scanner--1_56j","bottleEntryHint":"📦Sample__bottleEntryHint--HQPVf","confirmModal":"📦Sample__confirmModal--2Sz9e"};